export const categories = [
  {
    slug: "ai-meinv-xiezhen",
    name: "AI美女写真",
    description: "专业级AI美女写真生成，涵盖职场、古典、现代等多种风格，打造高级质感人像大片。",
    icon: "ri-camera-lens-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20AI-generated%20beautiful%20Asian%20woman%20professional%20photography%20portrait%2C%20soft%20studio%20lighting%2C%20minimalist%20cream%20background%2C%20sophisticated%20fashion%20style%2C%20high%20quality%20digital%20art%2C%20warm%20neutral%20tones%2C%20editorial%20photography%20aesthetic&width=800&height=600&seq=cat-01&orientation=landscape",
    count: 128,
    featured: true,
  },
  {
    slug: "ai-meinv-touxiang",
    name: "AI美女头像",
    description: "精致AI美女头像生成，甜美、时尚、高冷等多种风格任选，打造专属社交媒体形象。",
    icon: "ri-user-heart-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20AI-generated%20Asian%20woman%20portrait%20close-up%2C%20soft%20natural%20lighting%2C%20minimalist%20neutral%20background%2C%20gentle%20smile%2C%20fresh%20makeup%2C%20high%20quality%20digital%20art%2C%20warm%20cream%20tones%2C%20social%20media%20profile%20style&width=800&height=600&seq=cat-02&orientation=landscape",
    count: 256,
    featured: true,
  },
  {
    slug: "ai-meinv-bizhi",
    name: "AI美女壁纸",
    description: "精美AI美女壁纸生成，唯美场景与AI美女完美融合，为你的设备增添视觉美感。",
    icon: "ri-smartphone-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Dreamy%20scenic%20AI-generated%20beautiful%20Asian%20woman%20wallpaper%2C%20golden%20sunset%20background%2C%20flowing%20dress%2C%20ethereal%20atmosphere%2C%20cinematic%20composition%2C%20high%20quality%20digital%20art%2C%20warm%20golden%20and%20rose%20tones%2C%20phone%20wallpaper%20style&width=800&height=600&seq=cat-03&orientation=landscape",
    count: 189,
    featured: true,
  },
  {
    slug: "ai-xuni-meinv",
    name: "AI虚拟美女",
    description: "创造独一无二的AI虚拟美女形象，自定义五官、发型、风格，打造理想中的完美形象。",
    icon: "ri-ghost-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Futuristic%20digital%20AI-generated%20beautiful%20Asian%20virtual%20woman%20character%2C%20clean%20modern%20aesthetic%2C%20minimalist%20studio%20lighting%2C%20high%20quality%203D%20render%20style%2C%20sleek%20design%2C%20warm%20neutral%20tones%2C%20virtual%20avatar%20concept&width=800&height=600&seq=cat-04&orientation=landscape",
    count: 95,
    featured: false,
  },
];